import { routeName as tableTimeAndLoad } from './TableTimeAndLoad'
import { routeName as productionCalendar } from './ProductionCalendar'
import { routeName as changelog } from './Changelog'

export const pages = {
  tableTimeAndLoad,
  productionCalendar,
  changelog
}
